import * as React from "react";

function SvgStatsig(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M221.495 105.75a7.499 7.499 0 000-7.5l-50-86.602A7.5 7.5 0 00165 7.898H65a7.5 7.5 0 00-6.495 3.75l-50 86.602a7.5 7.5 0 000 7.5l50 86.603a7.501 7.501 0 006.495 3.75h100a7.502 7.502 0 006.495-3.75l50-86.603z"
        fill="#194B7D"
        stroke="#194B7D"
        strokeWidth={15}
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.568 65.107c2.003-.479 3.694 1.535 2.874 3.426L172.69 100.26c-.739 1.705-3.015 2.036-4.209.612l-5.109-6.088-31.864 27.862a7.5 7.5 0 01-10.559-.682L99.832 98.047 75.544 119.19c.298 1.221.456 2.496.456 3.809 0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16c1.956 0 3.83.351 5.562.993L95.6 81.843a7.5 7.5 0 0110.547.693l21.106 23.905 26.475-23.15-5.128-6.111c-1.194-1.424-.473-3.607 1.334-4.039l33.634-8.034z"
        fill="#fff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgStatsig);
